module.exports = __webpack_public_path__ + "img/receive.849e8b75.svg";